/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type ExpenseRevenueRecognition_project$ref = any;
type FixedPriceOverview_project$ref = any;
type RevenueRecognition_project$ref = any;
type TimeRevenueRecognition_project$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type RevenueRecognitionPage_project$ref: FragmentReference;
declare export opaque type RevenueRecognitionPage_project$fragmentType: RevenueRecognitionPage_project$ref;
export type RevenueRecognitionPage_project = {|
  +id: string,
  +rateCard: ?{|
    +id: string,
    +currency: ?string,
  |},
  +$fragmentRefs: RevenueRecognition_project$ref & FixedPriceOverview_project$ref & TimeRevenueRecognition_project$ref & ExpenseRevenueRecognition_project$ref,
  +$refType: RevenueRecognitionPage_project$ref,
|};
export type RevenueRecognitionPage_project$data = RevenueRecognitionPage_project;
export type RevenueRecognitionPage_project$key = {
  +$data?: RevenueRecognitionPage_project$data,
  +$fragmentRefs: RevenueRecognitionPage_project$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RevenueRecognitionPage_project",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "RateCard",
      "kind": "LinkedField",
      "name": "rateCard",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currency",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RevenueRecognition_project"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FixedPriceOverview_project"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TimeRevenueRecognition_project"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ExpenseRevenueRecognition_project"
    }
  ],
  "type": "ProjectType"
};
})();
// prettier-ignore
(node/*: any*/).hash = '9fb93e91ce33a7324336f3df6f0d390a';

module.exports = node;
